import AddDeduction from './AddDeduction';

export default AddDeduction;